import { FEATURE_FLAGS } from '@mondaygpt/constants'
import { useFeatureGateState } from 'modules/feature-flags'

/**
 * Reactive `engagement_section` gate — see `useFeatureGateState` for the
 * settled-identity semantics.
 */
export function useEngagementGate(): { enabled: boolean; settled: boolean } {
  return useFeatureGateState(FEATURE_FLAGS.engagementSection)
}
